/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 16,
    height: 16,
    viewBox: '0 0 13.56 17.91',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M.5 7.27h12.56v3.85a6.28 6.28 0 01-6.28 6.28h0A6.28 6.28 0 01.5 11.13V7.27h0zM2.67 7.27V4.42A3.92 3.92 0 016.59.5h0a3.92 3.92 0 013.91 3.92v2.85" _fill="none" _stroke="#c4c4c4" stroke-miterlimit="10"/><circle pid="1" cx="6.78" cy="11.09" r="1.66" _fill="#74777a"/><path pid="2" _fill="none" _stroke="#74777a" stroke-miterlimit="10" d="M6.78 11.09v3.5"/></g></g>'
  }
})
